export const fade = {
  exited: {
    opacity: 0,
  },
  entered: {
    opacity: 1,
  },
  animationEntering: `
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`,
  animationExiting: `
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`,
};
